export default __webpack_public_path__ + "static/media/DtVjJx26TKEr37c9aAFJn3YO5gjupg.5e972b67.woff2";